import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=b96aebec"
import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports